module.exports = __webpack_public_path__ + "static/芝山捷運站-DSC05525-9ece6200d0190614159ecb66f57443d4.jpg";